/*
  Maps shelf names to objects that in turn map book IDs to shelvings,
  indicating that the current user has shelved those books on the named shelf.
  i.e.:

  {'to-read': {[bookId]: {…}, [bookId2]: {…}},
   'currently-reading': {…},
   …
  }

  LIMITATION: only maps exclusive shelves

  This store gets its data by listening to ShelvingsStore. It serves as another
  "view" of the ShelvingsStore data.
*/
import _ from "lodash";
import Reflux from "reflux";
import Freezer from "freezer-js";
import ShelvingsStore from "./shelvings_store";

const state = new Freezer({});

export default Reflux.createStore({
  getState: state.get,
  getInitialState: state.get,

  init() {
    this.listenTo(ShelvingsStore, this.onShelvingsStoreChange);
  },

  reset() {
    this.getState().reset({});
  },

  onShelvingsStoreChange(shelvingsStoreData) {
    if (_.isUndefined(shelvingsStoreData)) {
      this.getState().set({});
    } else {
      // Book IDs shelved here in BooksOnShelvesStore
      const bossShelvedBookIds = {};

      _.forOwn(shelvingsStoreData, (shelving) => {
        // If shelving data includes book data...
        if (_.has(shelving, "book.bookId")) {
          // ...and we haven't already recorded this book...
          if (!_.has(bossShelvedBookIds, shelving.book.bookId)) {
            bossShelvedBookIds[shelving.book.bookId] = true;

            // ...and the shelving data includes an exclusive shelf name...
            if (shelving.exclusiveShelfName !== null) {
              // If this is a shelf name we haven’t recorded before, add that
              // shelf name key to our state object
              if (!_.has(this.getState(), shelving.exclusiveShelfName)) {
                this.getState().set(shelving.exclusiveShelfName, {});
              }

              this.getState()[shelving.exclusiveShelfName]
                .set(shelving.book.bookId, _.cloneDeep(shelving));
            }
          }
        }
      });
    }

    // Remove shelvings that no longer appear in ShelvingsStore
    // Grabbing data from shelvingsStore by using bookId as a key is not a bug --
    // if there are other books in the work that have been shelved, we're still
    // allowed to remove that book from booksOnShelvesStore, since only that
    // book was shelved, not the work.
    _.forOwn(this.getState(), (shelfMap, shelfName) => {
      _.each(_.keys(shelfMap), (bookId) => {
        // EV-1770: Sometimes remove isn't a function so don't call it
        if ((_.isUndefined(shelvingsStoreData[bookId]) ||
              shelvingsStoreData[bookId].exclusiveShelfName === null) &&
              _.isFunction(this.getState()[shelfName].remove)) {
          this.getState()[shelfName].remove(bookId);
        }
      });

      // If no shelvings for this shelf name, remove it entirely
      // EV-1770: Sometimes remove isn't a function so don't call it
      if (_.isEmpty(this.getState()[shelfName]) &&
            _.isFunction(this.getState().remove)) {
        this.getState().remove(shelfName);
      }
    });

    this.trigger(this.getState());
  },

  // Old pieces of BookStore stripped out during GR-30566
  /*
  let addBookToShelf = function(book) {
    let values = this.getState();
    values.books.push(book);
  };

  let updateState = function(shelfName, books) {
    let values = this.getState();
    values.set("name", shelfName);
    values.books.reset(books);
  };

  getUserShelf: function(shelfName) {
    $j.ajax({
      url: "/route_deleted/",
      type: "GET",
      dataType: "json",
      data: { shelfName: shelfName },
      success: (resp) => {
        updateState(shelfName, resp);
        this.trigger(this.getState());
      }
    });
  },

  onAddBookToShelf: function(book, shelfName) {
    $j.ajax({
      url: "/review.json/",
      type: "POST",
      data: { shelf: shelfName, book_id: book.bookId },
      success: (resp) => {
        addBookToShelf(resp);
        this.trigger(this.getState());
      }
    });
  },

  onRemoveBookFromShelf: function(book) {
    $j.ajax({
      url: "/review/destroy/",
      type: "DELETE",
      data: { id: book.bookId, format: "json" }
    });
  }

  onChooseDisplayShelf: function(shelfName) {
    this.getUserShelf(shelfName);
    this.onSetShowShelfListValue(false);
  },

  onSetShowShelfListValue: function(value) {
    let values = this.getState();
    values.set("showShelfList", value);
    this.trigger(this.getState());
  },

  */

});
